import { render, staticRenderFns } from "./RulebookVersionsTab.vue?vue&type=template&id=2aadd7c6&scoped=true&"
import script from "./RulebookVersionsTab.vue?vue&type=script&lang=js&"
export * from "./RulebookVersionsTab.vue?vue&type=script&lang=js&"
import style0 from "./RulebookVersionsTab.vue?vue&type=style&index=0&id=2aadd7c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aadd7c6",
  null
  
)

export default component.exports